import React from 'react';
import { Section } from './ui/Section';
import { Timer, UserX, UserCheck } from 'lucide-react';
export function RealProblem() {
  return <Section className="bg-[#0F1525]" data-id="element-257">
      <div className="max-w-4xl mx-auto" data-id="element-258">
        <div className="text-center mb-16" data-id="element-259">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-balance" data-id="element-260">
            El Problema No Es Tu Talento. <br data-id="element-261" />
            <span className="text-brand-accent" data-id="element-262">Es Tu Presencia Digital.</span>
          </h2>
          <p className="text-xl text-slate-400" data-id="element-263">Seamos honestos.</p>
        </div>

        <div className="bg-brand-surface border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-264">
          {/* Decorative background element */}
          <div className="absolute -top-24 -right-24 w-48 h-48 bg-brand-accent/10 rounded-full blur-3xl" data-id="element-265"></div>

          <div className="relative z-10" data-id="element-266">
            <div className="flex items-center gap-4 mb-8" data-id="element-267">
              <div className="p-3 bg-brand-dark rounded-lg border border-white/10" data-id="element-268">
                <Timer className="w-6 h-6 text-brand-accent" data-id="element-269" />
              </div>
              <p className="text-lg text-slate-300" data-id="element-270">
                En el mundo de hoy, antes de contratarte, tus clientes
                potenciales te buscan en Google. Revisan tu web.
              </p>
            </div>

            <div className="mb-10" data-id="element-271">
              <h3 className="text-2xl font-bold text-white mb-6" data-id="element-272">
                En menos de{' '}
                <span className="text-brand-accent" data-id="element-273">7 segundos</span> toman una
                decisión inconsciente:
              </h3>

              <div className="grid sm:grid-cols-2 gap-6" data-id="element-274">
                <div className="bg-emerald-500/10 border border-emerald-500/20 p-6 rounded-xl relative" data-id="element-275">
                  <UserCheck className="absolute top-4 right-4 w-6 h-6 text-emerald-500/50" data-id="element-276" />
                  <p className="text-lg font-medium text-emerald-400 italic" data-id="element-277">
                    "Este es un profesional que puede ayudarme"
                  </p>
                </div>

                <div className="bg-red-500/10 border border-red-500/20 p-6 rounded-xl relative" data-id="element-278">
                  <UserX className="absolute top-4 right-4 w-6 h-6 text-red-500/50" data-id="element-279" />
                  <p className="text-lg font-medium text-red-400 italic" data-id="element-280">
                    "No parece muy serio. Voy a seguir buscando."
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-4 text-lg text-slate-300 border-t border-white/10 pt-8" data-id="element-281">
              <p data-id="element-282">
                No importa cuánto talento tengas. No importa cuántos años de
                experiencia acumules.
              </p>
              <p className="font-semibold text-white text-xl" data-id="element-283">
                Si tu presencia digital no transmite autoridad, estás perdiendo
                la venta antes de que empiece.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}